import BeanEmpty from '@/assets/icons/rating-bean-empty.svg';
import BeanFull from '@/assets/icons/rating-bean-full.svg';
import BeanHalf from '@/assets/icons/rating-bean-half.svg';

interface RatingDisplayProps {
  score: number;
  maxScore?: number;
  size?: 'md' | 'lg' | 'responsive';
  className?: string;
}

const BEAN_CLASS = {
  md: 'h-8 w-6',
  lg: 'h-12 w-8',
  // Large on mobile, medium from `md` up — keeps the feed card's score row
  // bold on phones without turning oversized on the wider desktop card.
  responsive: 'h-12 w-8 md:h-8 md:w-6',
} as const;

const GAP_CLASS = {
  md: 'gap-2',
  lg: 'gap-1',
  responsive: 'gap-1 md:gap-2',
} as const;

export function RatingDisplay({
  score,
  maxScore = 5,
  size = 'md',
  className = '',
}: RatingDisplayProps) {
  const clampedScore = Math.max(0, Math.min(score, maxScore));
  const fullBeans = Math.floor(clampedScore);
  const hasHalfBean = clampedScore % 1 >= 0.5;
  const emptyBeans = maxScore - fullBeans - (hasHalfBean ? 1 : 0);

  const beanClass = BEAN_CLASS[size];
  const gapClass = GAP_CLASS[size];

  const wrapperClass = `flex items-center ${gapClass}${className ? ` ${className}` : ''}`;

  return (
    <div className={wrapperClass} data-testid="bean-row">
      {Array.from({ length: fullBeans }).map((_, i) => (
        <img
          key={`full-${String(i)}`}
          src={BeanFull}
          alt=""
          className={beanClass}
          aria-hidden="true"
        />
      ))}
      {hasHalfBean && (
        <img
          src={BeanHalf}
          alt=""
          className={beanClass}
          aria-hidden="true"
        />
      )}
      {Array.from({ length: emptyBeans }).map((_, i) => (
        <img
          key={`empty-${String(i)}`}
          src={BeanEmpty}
          alt=""
          className={beanClass}
          aria-hidden="true"
        />
      ))}
    </div>
  );
}
